module.exports = __webpack_public_path__ + "static/media/may.7a8e1f6f.png";